import { StepType } from 'src/app/shared/shared.module';
import {
    getInputField, setAsRequired, setRegexValidation,
    getSelectField, getTypeAheadField, getDateField, MinMaxAgeMustBe, getTelephoneField, setDisablewithValueWhen, setAsRequiredEmail
} from 'src/app/shared/form';
import { VisaType } from '../../visatypes';
import { isNullOrUndefined } from '../../../../../../app/core/utils';
import { setDisablePhoneFieldWhen, setYesNoValues } from '../../../../../shared/form/form-utils';
import { FieldTooltip } from '../../field-tooltip.enum';
import { map } from 'rxjs/operators';

export class IqamaTransfer extends VisaType {


    GetRequesterSteps(operations?: () => string[]): StepType[] {

        return [


            {
                label: "Step 1",
                fields: [
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                            this.EmpProfileSearch(null, operations),

                        ]
                    },
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                            this.nonMandatoryGpn(),
                            this.nonMandatoryGui(),
                            //this.gpnGuiSearchButton(operations)
                        ]
                    },
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                            this.firstName(),
                            this.middleName(),
                            this.lastName()
                        ]
                    },
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                            this.nationalityTypeWithSpecialExpact(),  
                            this.nationality(),
                            // this.onboardingType(
                            //     this.common.getPbTypeWrtNationality()
                            // ),
                        ]
                    },
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                            getSelectField(
                                "specialExpat",
                                "Special expat",
                                setYesNoValues(this.common.getSpecialExpactWrtNationalityType(setAsRequired(this.addFieldTooltipWithAdditionalConfig('special expat')))
                            )),
                            getTelephoneField("Mobile number", setDisablePhoneFieldWhen((model) => model.isAutoGenerated == 1 && !isNullOrUndefined(model.phoneNumber), setAsRequired(this.addFieldTooltipWithAdditionalConfig('Mobile number')))),
                            getInputField("emailAddress", "Email address", setDisablewithValueWhen((model) => model.isAutoGenerated == 1 && !isNullOrUndefined(model.emailAddress),
                                setAsRequiredEmail(this.addFieldTooltipWithAdditionalConfig('Email address',
                             )))),

                        ]
                    },
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                            this.gender(),
                            getSelectField(
                                "serviceLine.id",
                                "Service line",
                                this.common.getSelectFieldOptions(this.serviceLines$, '',
                                    setAsRequired())
                            ),
                            getSelectField(
                                "subServiceLine.id",
                                "Sub-service line",
                                this.common.getSelectFieldOptions(this.subServiceLines$, "serviceLine.id",
                                    setAsRequired())
                            ),
                            this.rank(),
                            this.officeLocation(),
                            this.officeLE('EY Legal entity name'),
                        ]

                    },     
                
                
                ]
            },
            {
                label: "Step 2",
                fields: [
                   
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                            // this.grade(),
                            getInputField("academicQualification", "Academic qualification", setAsRequired( 
                                this.addFieldTooltipWithAdditionalConfig('Academic qualification',

                            ))),
                            // this.visaAgent() ,
                            getDateField("startDate", "Start date", setAsRequired(
                                this.addFieldTooltipWithAdditionalConfig('start date',
                                setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
                                    "Please enter a valid date in 'dd-mm-yyyy' format",
                                    this.common.AcceptDateAfter(0, 'Start date cannot be a past date', 'Start date', true, null))))),
                            getSelectField("ptc.id", "PJC name",
                                this.addFieldTooltipWithAdditionalConfig('PJC name',
                                    setAsRequired(this.common.getEmployeeSelectFieldOptions(this.ptcs$)))),
                            getInputField(
                                "saSerialNumber",
                                "IBAN Number",
                                setAsRequired()
                            ),
                            getSelectField("immigrationCaseType.id", "Immigration case type",this.common.getRequiredSelectFieldOptions(this.immigrationCaseType$,setAsRequired())),          
                            // getSelectField("immigrationCaseType.id", "Immigration case type",
                            //     this.common.getSelectFieldOptionsWithDisable(this.immigrationCaseType$.pipe(map(item => item.filter(i => [1016, 1017, 1005, 1006].includes(i.id)))), [1005, 1006],

                            //         setAsRequired())
                            // ),
                            this.iqamaNumber(setAsRequired()),
                            this.RequestorName()
                        ]

                    
                    }
                ]
            },

        ];

    }



    GetAccepterSteps(): StepType[] {
        return [
            {
                label: "Step 1",
                fields: [
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                          this.visaProcessorByOfficeLE(setAsRequired()),
                        //   this.Requestor()
                        ]
                    }
                ]
            }
        ];
    }



    GetApproverSteps(): StepType[] {

        return [
            {
                label: "Step 1",
                fields: [
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                            this.visaProcessorByOfficeLE(
                                setAsRequired()
                                ),
                          this.immigrationStatus(),
                            // this.passportNumber(),
                            // getInputField("passportNumber", "Passport number"),
                            // this.passportExpiryDate('Passport expiry date'),
                            // this.passportExpiryDateOptional('Passport expiry date'),
                            // this.dateOfBirth(MinMaxAgeMustBe(10, 100, 'Date of birth cannot be in the past 10 years or in the future')),
                            // this.dateOfBirthOptional(MinMaxAgeMustBe(10, 100, 'Date of birth cannot be in the past 10 years or in the future')),
                            // this.placeOfBirth(),
                            // getInputField("placeOfBirth", "Place of birth (City,Country)"),
                            getInputField("visaDesignation",
                                "Visa designation",
                                setAsRequired()
                                ),
    
                        //   this.Requestor()
                        ]
                    }
                ]
            }
        ];
    }

}
